<template>
<div>
  <section class="content">
    <!-- Default box -->
    <!-- <div class="box">
      <div class="box-header with-border">
        <h3 class="box-title">Banks List</h3>
        <span class="float-right">
          <button type="button"  v-if="canAccess('bank-create')" class="btn btn-sm btn-success" @click="newModal">
            <i class="fa fa-plus"></i>
          </button>
        </span>

        <div class="box-tools pull-right">
          <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip" title="" data-original-title="Collapse">
            <i class="fa fa-minus"></i></button>
          <button type="button" class="btn btn-box-tool" data-widget="remove" data-toggle="tooltip" title="" data-original-title="Remove">
            <i class="fa fa-times"></i></button>
        </div>
      </div>
      <div class="box-body">
        <vue-good-table
          :columns="columns"
          :rows="rows"
          styleClass="vgt-table condensed"
          :line-numbers="true"
          :pagination-options="{
            enabled: true,
            perPage: 10,
            perPageDropdown: [10, 20, 30],
          }"
          :search-options="{
            enabled: true,
            trigger: 'enter',
          }"
        >
          <template slot="table-row" slot-scope="props">  
            <span v-if="props.column.field == 'Status'">
              <span
                v-if="props.row.status == 'active'"
                class="label label-success"
                >Active</span
              >
              <span v-else class="label label-danger">InActive</span>
            </span>
            <span v-if="props.column.field == 'id'">
              <button v-if="canAccess('bank-update')"
                type="button"
                @click="editModal(props.row)"
                class="btn btn-success btn-xs"
              >
                <i class="fa fa-pencil"></i>
              </button>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
              
      </div>
      <div class="box-footer">
        List of all Banks
      </div>
    </div> -->
    <!-- /.box -->

     <!-- Default box -->
      <div class="info-box"  v-if="canAccess('bank-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Bank List</h3>
          
          <div class="box-tools">
            <button type="button" class="btn btn-success btn-sm" @click="newModal" v-if="canAccess('bank-create')">
              <i class="fa fa-plus"></i> Add New
            </button>
          </div>

        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <label>
                <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
            <div class="col-sm-6 col-xs-6">
              <div class="input-group pull-right input-group-sm" style="width: 150px;">
                <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search">

                <div class="input-group-btn">
                  <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-sm table-bordered table-hover">
            <thead style="background-color: #d6dddd;">
              <tr>
                <th class="hidden-xs">Sr. No.</th>
                <th>Name</th>
                <th class="hidden-xs">Short Name</th>
                <th class="hidden-xs">Status</th>
                <th>Action</th>

                <!-- <th v-if="$gate.isAdmin()">Status</th>
                <th>Image</th>
                <th v-if="$gate.isAdmin()">Modify</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in rows.data" :key="index">
                <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                <td>{{ row.name }}</td>
                <td class="hidden-xs">{{ row.shortName }}</td>
                <td class="hidden-xs">
                  <div v-if="row.status == 'active'">
                    <span class="label label-success">Active</span>
                  </div>
                  <div v-else>
                    <span class="label label-danger">InActive</span>
                  </div>
                </td>
                <td>
                  <div class="btn-group">
                    <button
                      v-if="canAccess('bank-update')"
                      @click="editModal(row)"
                      class="btn btn-success btn-xs"
                    >
                      <i class="fa fa-pencil"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer clearfix" v-if="pagination.current_page > 0">
          <div class="row">
            <div class="col-sm-4">
              Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
            </div>
            <div class="col-sm-8">
              <ul class="pagination pagination-sm no-margin pull-right">
                <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>

                <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                <li><a href="#">...</a></li>
                
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

                <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- /.box -->
  </section>    
  <div class="modal fade" id="newModal">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header bg-aqua">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 v-show="!editMode" class="modal-title">Add New</h4>
          <h4 v-show="editMode" class="modal-title">Update</h4>
          
        </div>
        <form @submit.prevent.once="editMode ? updateBank() : createBank()">
          <div class="modal-body">
            <!-- general form elements disabled -->
            <div class="card card-warning">
              <!-- /.card-header -->
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-6">
                    <!-- text input -->
                    <div class="form-group">
                      <label>Name <span class="red">*</span></label>
                      <input
                        v-model="form.name"
                        type="text"
                        name="name"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('name') }"
                      />
                      <has-error :form="form" field="name"></has-error>
                    </div>

                    <div class="form-group">
                      <label>Short Name <span class="red">*</span></label>
                      <input
                        v-model="form.shortName"
                        type="text"
                        name="shortName"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('shortName'),
                        }"
                      />
                      <has-error
                        :form="form"
                        field="shortName"
                      ></has-error>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label
                        >Select Status <span class="red">*</span></label
                      >
                      <select
                        v-model="form.status"
                        name="status"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('status'),
                        }"
                      >
                        <option v-if="!form.status" selected value="">
                          Select Status
                        </option>
                        <option value="active">Active</option>
                        <option value="inActive">Inactive</option>
                      </select>
                      <has-error :form="form" field="status"></has-error>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
          <div class="modal-footer text-center">
            <button
              v-show="!editMode"
              type="submit"
              class="btn btn-success"
            >
              CREATE
            </button>
            <button v-show="editMode" type="submit" class="btn btn-success">
              UPDATE
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
            >
              CANCEL
            </button>
          </div>
        </form>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->   
</div>
</template>

<script>
export default {
  name: 'Bank',
  data () {
    return {
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      per_page: 10,
      table_search: '',
      editMode: false,
      form: new Form({
        id: '',
        name: '',
        shortName: '',
        status: ''
      }),
      // columns: [
      //   {
      //     label: 'NAME',
      //     field: 'name'
      //   },

      //   {
      //     label: 'SHORT NAME',
      //     field: 'shortName'
      //   },
      //   {
      //     label: 'STATUS',
      //     field: 'Status'
      //   },

      //   {
      //     label: 'ACTIONS',
      //     field: 'id',
      //     type: 'number'
      //   }
      // ],
      rows: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    newModal () {
      this.editMode = false
      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
      // $('#newModal').modal('show')
    },

    createBank () {
      this.$axios
        .post('bank', this.form, {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Bank Added Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
      // this.$axios
      //   .post('bank', this.form, {
      //     headers: { Authorization: 'Bearer ' + localStorage.token }
      //   })
      //   .then(() => {
      //     Fire.$emit('AfterCreate')
      //     $('#newModal').modal('hide')
      //     Toast.fire({
      //       icon: 'success',
      //       title: 'Bank Added Successfully'
      //     })
      //   })
      //   .catch(
      //     function (error) {
      //       Toast.fire({ icon: 'error', title: 'Please Try Again' })
      //       this.form.errors.errors = error.response.data.error
      //     }.bind(this)
      //   )
    },

    editModal (row) {
      this.editMode = true
      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
      // $('#newModal').modal('show')
      this.form.fill(row)
    },
    updateBank () {
      // console.log('update data')

      this.$axios
        .put('bank/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Bank Details Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    changeFilter (page = null, pg = null) {
      var pageUrl = ''
      if (this.pagination.first_page_url && pg === 'first') {
        pageUrl += this.pagination.first_page_url
      } else if (this.pagination.last_page_url && pg === 'last') {
        pageUrl += this.pagination.last_page_url
      } else if (this.pagination.next_page_url && pg === 'next') {
        pageUrl += this.pagination.next_page_url
      } else if (this.pagination.prev_page_url && pg === 'prev') {
        pageUrl += this.pagination.prev_page_url
      } else if (this.pagination.path != null) {
        pageUrl += this.pagination.path
      } else {
        pageUrl += 'bank'
      }

      if (pg == null) {
        pageUrl += `?per_page=${this.per_page}`
      } else {
        pageUrl += `&per_page=${this.per_page}`
      }
      if (this.table_search) {
        pageUrl += `&searchTerm=${this.table_search}`
      }
      if (page != null) {
        pageUrl += `&page=${page}`
      }
      this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          console.log(data)
          this.rows = data.data
          this.pagination = data.data
        }).catch(function (error) { console.log(error) })
    }
    // loadData () {
    //   let loader = this.$loading.show()
    //   this.$axios
    //     .get('bank?all=all', {
    //       headers: { Authorization: 'Bearer ' + localStorage.token }
    //     })
    //     .then((response) => response.data)
    //     .then((data) => {
    //       loader.hide()
    //       this.rows = data.data
    //     })
    //     .catch(function (error) {
    //       Swal.fire({
    //         icon: 'error',
    //         title: 'Oops...',
    //         text: error
    //       })
    //     })
    // }
  },

  created () {
    this.changeFilter()
    Fire.$on('AfterCreate', () => {
      this.changeFilter()
    })
  }
}
</script>
<style scoped>
.content {
  padding: 0px;
}
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// Bank.vue?e06ae10c